export default __webpack_public_path__ + "static/Hush_Puppies-1336cb57eedce79e01d13c91d76ae400.jpg";